<template>
  <div class="common-no-data fb fb-col fb-cross-center fb-main-center">
    <div class="item-flex-1"></div>
    <slot></slot>
    <p v-if="content" class="pb-24 font-28 no-text">{{ content }}</p>
    <div class="item-flex-2"></div>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.common-no-data {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  .no-text {
    color: rgba(23, 26, 29, 0.4);
  }
}
</style>
